module.exports = __webpack_public_path__ + "img/yoga-mat-purple-min.b0b63a81.jpg";